import {Provider} from '@angular/core';
import {AppConfigHttpAdapter} from '@features/app-config/infrastructure/http/app-config.http.adapter';
import {AppConfigPort} from '@features/app-config/application/ports/app-config.port';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';

export const AppConfigHttpAdapterProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: AppConfigPort,
    useClass: AppConfigHttpAdapter
  }
];
